import React from 'react';

import Forbidden from '@/components/common/Forbidden';
import { useCanReadAdminData } from '@/hooks/useCanReadAdminData';

/** Renders children only for callers who may read administration data. */
export function RequireAdminData({ children }: { children: React.ReactNode }) {
  const allowed = useCanReadAdminData();
  if (!allowed) {
    return (
      <Forbidden message='หน้านี้ดูได้เฉพาะ Admin ขององค์กรและ Platform admin' />
    );
  }
  return <>{children}</>;
}

export default RequireAdminData;
